import createIcon from './utils/createIcon.js';
import '@babel/runtime/helpers/esm/extends';
import 'react';
import './utils/SvgIcon.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';

/* eslint-disable */
var InfoCircleSmall = createIcon({
  paths: ['M10 8H8v1h1v4H8v1h3v-1h-1zM9 6h1v1H9V6z', 'M9.5 3C5.358 3 2 6.358 2 10.5S5.358 18 9.5 18s7.5-3.358 7.5-7.5S13.642 3 9.5 3zm0 14C5.916 17 3 14.084 3 10.5S5.916 4 9.5 4 16 6.916 16 10.5 13.084 17 9.5 17z'],
  height: 20,
  width: 20
});

export default InfoCircleSmall;
//# sourceMappingURL=InfoCircleSmall.js.map
